import { all, call } from 'redux-saga/effects';

import { deleteSingleSpreadsheetSaga } from '@sagas/savedFilingPeriod/deleteSingleSpreadsheetSaga';

export const deleteSpreadsheetsSaga = function* ({ payload }) {
  const effects = payload.map(file => call(deleteSingleSpreadsheetSaga, { payload: file }));

  yield all(effects);
};
